var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{staticClass:"custom-footer"},[_c('div',{staticClass:"footer-content"},[_c('p',[_vm._v(" "+_vm._s(_vm.year)+" © JBI "),[_vm._v(" | Version: "+_vm._s(_vm.majorVersion)+"."+_vm._s(_vm.minorVersion)+", Build: "+_vm._s(_vm.patchVersion)+" ")]],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }